import { useMemo } from 'react';
import {
	Content,
	MainContentColumn,
	MainContentWrapper,
	ShapeWrapper,
	Title,
} from './CaseStudyMainContent.styles';
import { Circle, Polygon, SemiCircle } from './shapes';

const colorMap: { [key: string]: string } = {
	green: '#77DA74',
	orange: '#FFCC34',
	pink: '#FFACC5',
};

const CaseStudyMainContent = ({
	title,
	content,
	shape,
	color,
	contentPosition,
}: CaseStudyMainContentProps) => {
	const ShapeComponent = useMemo(() => {
		switch (shape) {
			case 'circle':
				return Circle;
			case 'polygon':
				return Polygon;
			case 'semicircle':
				return SemiCircle;
			default:
				return Circle;
		}
	}, [shape]);
	return (
		<MainContentWrapper reverse={contentPosition === 'left'}>
			<MainContentColumn>
				<Title>{title}</Title>
				<ShapeWrapper>
					<ShapeComponent fill={colorMap[color]} size={180} />
				</ShapeWrapper>
			</MainContentColumn>
			<MainContentColumn>
				<Content>{content}</Content>
			</MainContentColumn>
		</MainContentWrapper>
	);
};

export type CaseStudyMainContentProps = {
	title: string;
	content: string;
	shape: 'circle' | 'semicircle' | 'polygon';
	color: 'green' | 'orange' | 'pink';
	contentPosition: 'left' | 'right';
};

export default CaseStudyMainContent;
